"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.ThemeProvider = exports.withTheme = exports.useTheme = void 0;
var react_1 = require("@emotion/react");
var react_2 = require("@emotion/react");
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return react_2.useTheme; } });
Object.defineProperty(exports, "withTheme", { enumerable: true, get: function () { return react_2.withTheme; } });
exports.ThemeProvider = react_1.ThemeProvider;
exports.defaultTheme = {
    colors: {
        primary: '#3A23AD',
        secondary: '#00cee1',
        hover: '#f8f6fd',
        text: {
            secondary: '#ffffff',
        },
        message: {
            error: '#cc1212',
            warning: '#ecaa15',
            info: '#4c3ce2',
        },
    },
    components: {},
};
